// Setup Promise and Fetch everywhere
require('es6-promise/auto');
require('viewport-units-buggyfill').init();

import 'isomorphic-fetch';
import 'core-js/es6/promise';

import * as React                                  from 'react';
import * as ReactDOM                               from 'react-dom';
import * as PropTypes                              from 'prop-types';
import * as storage                                from 'localforage';

import { startSegment }                            from './helpers/segment';
import App                                         from './App';
import { Provider }                                from 'react-redux';
import createStore                                 from './reducers';
import env                                         from './env';
import { ConversationUrlParams }                   from './types';
import { RouteComponentProps }                     from 'react-router';
import { ApolloProvider }                          from 'react-apollo';
import { createClient }                            from './services/MessageTemplatesService';

import PrivateContainer, { PrivateContainerProps } from './sections/Login/PrivateContainer';

import {
    BrowserRouter as Router,
    Route
}                                                  from 'react-router-dom';

// avoids proxy inline script issue in app.statflo.com/messenger
if (window.hasOwnProperty('Typekit')) {
    (window as any).Typekit.load({ async: true });
}

if (env.SEGMENT_KEY) {
    startSegment();
}

interface AuthCheckProps extends RouteComponentProps<ConversationUrlParams>, PrivateContainerProps {}

const ROOT_ELEMENT           = document.getElementById('root');

storage.config({
    driver: [
        storage.INDEXEDDB,
        storage.LOCALSTORAGE
    ],
    name: env.STORAGE_KEY
});

const AuthProvider = PrivateContainer((props) => <div>{props.children}</div>);

const RefreshToBindSSO = () => window.location.href = env.CONVERSATION_UI_DEV || `${env.WEBAPP_HOST}messenger`;

const AuthCheck: React.StatelessComponent<AuthCheckProps> = (props, context) => context.session ? (
    <ApolloProvider client={createClient(context.session)} >
        <App {...(props as AuthCheckProps)} />
    </ApolloProvider>
) : null;

AuthCheck.contextTypes = {
    session: PropTypes.any
};

export const store = createStore();

const render = () => {
    ReactDOM.render(
        <Provider store={store}>
            <AuthProvider>
                <Router basename={window.location.href.match(env.WEBAPP_HOST) ? 'messenger' : ''}>
                    <div>
                        <Route path="/login" component={RefreshToBindSSO} />
                        <Route path="/" component={AuthCheck} />
                    </div>
                </Router>
            </AuthProvider>
        </Provider>,
        ROOT_ELEMENT
    );
};

if (
    'Map' in window &&
    'Set' in window &&
    'includes' in String.prototype &&
    'find' in Array.prototype &&
    'includes' in String.prototype
) {
    render();
} else {
    import('./polyfills').then(render);
}



// WEBPACK FOOTER //
// ./src/index.tsx